import { useState, useMemo } from 'react';

export default (initialValues = {}) => {
    const [values, setValues] = useState(initialValues);

    const setValue = (key, value) => setValues({ ...values, [key]: value });

    const onChange = (key) => (ev) => {
        const target = ev.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        setValue(key, ev.target ? value : ev);
    };

    const setCustomFieldValue = (key, index, value, requiredField)  => {
        let obj = JSON.parse(JSON.stringify(values[key]));
        if (requiredField) {
            obj[index].required = value;
        }
        else{
            obj[index].required = !value ? false : obj[index].required;
            obj[index].selected = value;
        }
        setValues({ ...values,[key]:obj });
    };

    const isDirty = useMemo(() => {
        return JSON.stringify(values) !== JSON.stringify(initialValues);
    }, [values, initialValues]);


    return {
        values,
        isDirty,
        reset: () => setValues(initialValues),
        setArrayValue: (key, index, value, requiredField) => setCustomFieldValue(key, index, value, requiredField),
        handlers: Object.keys(values).reduce(
            (acc, key) => ({
                ...acc,
                [key]: { value: values[key], onChange: onChange(key) },
            }),
            {}
        ),
    };
};
